import type { FaireProductEntity } from "../../entity_types/product";

export const p_cq2tery3mu: FaireProductEntity = {
  token: "p_cq2tery3mu",
  type: "product",
  name: "Mega Matcha - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/a3defd64a3f8bc1b5882373d319cc73f06a2b68309c9caa65b943bdbf31857c2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f36cbcd900a865acb83849d4f7e01f251ae270ae2124f6a2769cde1567b9478c.png",
    "https://cdn.faire.com/fastly/37cecef53008e7e515e3ca8c651318f9ec567c241ae7e3f879f09e9c92ae2845.jpeg",
    "https://cdn.faire.com/fastly/e23b140fb3eb28c524c6f4ee017c26fc2d0c62b95d5caba0e6bdb68c72541012.png",
    "https://cdn.faire.com/fastly/1695c53f003c84cd121f8768d5981cc1e1681b176230b4b23c1ddaac8d6c529d.jpeg",
    "https://cdn.faire.com/fastly/88bf057568fe55823da51603fadb6c2c5b04e52b0ea72df445c95c7d203a1522.jpeg"
  ],
  priceDollars: 110,
  description: "Matcha Superfood Latte\n\n\nA matcha made in heaven! Mega Matcha blends the highest quality Japanese matcha with adaptogens reishi + ashwagandha, powering up its ability to relax the mind while promoting a smooth, feel-good boost of energy.\n\nShake, whisk or blend - your mood will thank you later.\n\n\"I am obsessed. This is the perfect afternoon pick-me-up\". - Marie T. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Matcha Latte: Whisk 3/4 tsp Mega Matcha with 1-2 tsp sweetener + a splash of water to combine. Top with 1 cup frothed or hot milk. \n * Stovetop Matcha: Heat Mega Matcha, milk and sweetener in a small pot for 3-5 min, whisking well, until bright green and combined. \n * Delicious served over ice, in oatmeal, baked goods, and smoothies! \nWhen to Enjoy:\n\n * As a substitute for your morning coffee \n * For a smooth boost of energy \n * When you need to boost your mood \nModerate caffeine levels\n",
  tags: [],
  msrpDollars: 220,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:46.026Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
